// extracted by mini-css-extract-plugin
export var bodyContent = "styles-module--bodyContent--74f4c";
export var cardTitles = "styles-module--cardTitles--cde35";
export var imageContent = "styles-module--imageContent--a925d";
export var textContent = "styles-module--textContent--fda19";